// Generated by Claude Code
import { Priced } from '#core/entities/operations/shared/Price.ts'

/** The company's default hourly labour rate. */
export class CompanyCostRate extends Priced {}

/** One user's hourly labour rate, overriding the company default. */
export class UserCostRate extends Priced {
  user_id = ''
}

/** Whether an hourly rate is one the backend accepts: finite and non-negative. */
export function isValidCostRate(amount: number): boolean {
  return Number.isFinite(amount) && amount >= 0
}
